import axios from "axios"


const baseURL = process.env.VUE_APP_SERVICES_ENDPOINT

const instence = axios.create({
    baseURL,
    withCredentials: true,
    headers: { 
        'Content-Type': 'application/json', 
    }
});

instence.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('accessToken');

        if (token) {
        config.headers['Authorization'] = `Bearer ${ token }`;
        }

        return config;
    }, 

    (error) => {
        return Promise.reject(error);
    }
);
// instence.interceptors.response.use(response => {
//     console.log('Response:', response)
//     return response
// })

export default instence